export const RESET = 'SERVER_LIST_RESET'
export const SET_ITEMS = 'SERVER_LIST_SET_ITEMS'
export const SET_ERROR = 'SERVER_LIST_SET_ERROR'
export const SET_VIEW = 'SERVER_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'SERVER_LIST_TOGGLE_LOADING'
